import { supabase } from '@/lib/supabase'
import type { FilterState, DashboardMetrics } from '@/types/lead-attribution'
import type { JobberSyncStats } from '../types'

export async function fetchJobberMetrics(filters: FilterState): Promise<DashboardMetrics> {
  try {
    console.log('Fetching dashboard metrics with filters:', filters)

    const { data, error } = await supabase.rpc('get_dashboard_metrics_aggregates', {
      p_franchise: filters.franchise && filters.franchise !== 'all' ? filters.franchise : null,
      p_date_start: filters.dateRange?.start.toISOString() ?? null,
      p_date_end: filters.dateRange?.end.toISOString() ?? null,
    })

    if (error) {
      console.error('Dashboard metrics RPC error:', error)
      throw error
    }

    if (!data) {
      throw new Error('Dashboard metrics RPC returned no data')
    }

    console.log('Dashboard metrics received from RPC:', data)

    return data
  } catch (error) {
    console.error('Error fetching dashboard metrics:', error)
    throw error
  }
}

export async function fetchJobberSyncStats(filters: FilterState): Promise<JobberSyncStats> {
  // TODO: Replace with real API call when sync stats endpoint is available
  // Currently returning mock data to match previous implementation
  console.log('Fetching Jobber sync stats with filters:', filters)
  
  // Simulate network delay
  await new Promise(resolve => setTimeout(resolve, 500))
  
  return {
    customers: {
      total: 1247,
      synced: 1203,
      pending: 44,
      errors: 0,
      lastSync: '2025-06-10T10:30:00Z'
    },
    jobs: {
      total: 856,
      synced: 823,
      pending: 28,
      errors: 5,
      lastSync: '2025-06-10T10:25:00Z'
    },
    invoices: {
      total: 634,
      synced: 628,
      pending: 4,
      errors: 2,
      lastSync: '2025-06-10T10:35:00Z'
    },
    estimates: {
      total: 432,
      synced: 425,
      pending: 6,
      errors: 1,
      lastSync: '2025-06-10T10:28:00Z'
    }
  }
}
